/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import JobPageMeta from "@/src/containers/Pages/Generic/JobsPage/JobPageMeta";
import JobsSection from "@/src/components/Jobs/JobsSection";
import WayWeWorkSection from "@/src/components/Jobs/WayWeWorkSection";
import JobBenefits from "@/src/components/Jobs/JobBenefits.tsx";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";

const JobOverviewPage = () => {
  return (
    <LayoutPublicRoutes>
      <JobPageMeta />
      <WayWeWorkSection />
      <JobsSection />
      <JobBenefits />
    </LayoutPublicRoutes>
  );
};

export default JobOverviewPage;
